import { Component, Input, OnInit } from "@angular/core";

import { BaseComponent, UserService, ProductService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

@Component({
  selector: "myp-recent-order",
  templateUrl: "recent-order.component.html",
  standalone: false,
})
export class RecentOrderComponent extends BaseComponent implements OnInit {
  @Input() stringId: string;
  public loading: boolean = false;
  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    private _productService: ProductService,
    private _router: Router
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loading = false;
    this._productService.getProducts(true).subscribe((result) => {
      this.loading = false;
    });
  }

  goToProduct(id) {
    this.activeModal.close(id);
  }
}
